import { products } from '@/configs/translates.config';

export default {
	'add-new-product': `add new ${products.en.singular}`,
	'the-product': `the ${products.en.singular}?`,
	product: products.en.singular,
	sellers: 'Sellers',
	confirm: 'confirm',
	'are-you-sure-you-want-to-$-this-product': `Are you sure you want to {state} this ${products.en.singular}?`,
	'up-selling-form': 'up-selling form',
	'link-product': 'link product',
	'view-stock': 'view stock',
	entry: 'entry',
	options: 'options',
	'in-cart': 'in cart',
	'offer-data': 'offer data',
	required: 'required'
}